import { ResizableImage } from 'mui-tiptap'

export const CustomResizableImage = ResizableImage.extend({
  addAttributes() {
    return {
      ...this.parent?.(),

      // The `width` attribute will be used by users to override/specify the width of
      // the image. If not specified, the image will display with its default/full
      // width, up to a `max-width: 100%` (via CSS styles). Height will be set to
      // "auto", so `width` will always determine sizing and we'll preserve the original
      // aspect ratio.
      width: {
        default: null,
        // How to render this attribute in the HTML, so it's serialized/saved
        // (and in this case, affects visuals)
        renderHTML: attributes => ({
          width: attributes.width as string | number | undefined
        }),
        // How to load this attribute from any existing HTML content
        parseHTML: element => element.getAttribute('width') ?? element.style.width
      },

      // The `aspectRatio` attribute will be used to set the `aspect-ratio` CSS
      // style, which ensures that whatever the width (the specific value set
      // via attribute or max-width of 100%, if the viewport is narrower than
      // that), the "height: auto" can be inferred even before the image loads,
      // making the page flash/jitter less before/after the image renders (see
      // https://developer.mozilla.org/en-US/docs/Web/CSS/aspect-ratio, and note
      // that the newer alternative approach they describe using
      // `attr(width) / attr(height)` does not work in Chrome and other browsers
      // yet). We'll make sure to set `aspectRatio` whenever a user resizes and
      // sets `width`, so that we improve initial page/image rendering.
      aspectRatio: {
        default: null,
        renderHTML: attributes => {
          if (!attributes.aspectRatio) {
            return {}
          }

          return {
            style: `aspect-ratio: ${attributes.aspectRatio as string}`
          }
        },
        parseHTML: element => element.style.aspectRatio
      }
    }
  }
})
